export default __webpack_public_path__ + "static/linkGenerationBackground-c742032a4da299e266327f61b93bbe16.png";